'use strict';
import $ from 'jquery';

export default class DropdownFilter {
  static init() {
    $('.dropdown-filter').each((index, el) => {
      new DropdownFilter($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    const self = this;
    this.ul = this.el.find('ul');
    this.el.find('p').on('click', this.selectDropdown.bind(this));
    this.ul.on('click', 'li', this.onClick.bind(this));
  }

  onClick(e) {
    const li = $(e.currentTarget);
    this.el.trigger('selected', li);
    this.el.find('p').html(li.text());
    this.selectDropdown();
  }

  selectDropdown() {
    const self = this;
    if (self.ul.is(':visible')) {
      self.ul.slideUp();
      self.el.removeClass('open');
    } else {
      self.el.addClass('open');
      self.ul.slideDown({
        start: function () {
          $(this).css({
            display: 'flex'
          });
        }
      });
    }
  }
}
